import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { WebService } from '../web-service';
import { TabsState } from 'app/state-management/tabs-state';
import { GetUserDataResponse, UpdateUserRequest, UserPreferences } from './user-data-service-types';
import { catchError, of } from 'rxjs';
import { UserState } from 'app/state-management/user-state';

@Injectable({
  providedIn: 'root',
})
export class UserDataService {
  constructor(
    private http: HttpClient,
    private webService: WebService,
    private tabsState: TabsState,
    private userState: UserState,
  ) {}
  getUserData(): Promise<GetUserDataResponse> {
    return new Promise(async (resolve, reject) => {
      try {
        this.http
          .get<GetUserDataResponse>(encodeURI(`${this.webService.rootService}/user/data`), {})
          .subscribe((res) => {
            resolve(res);

            this.userState.setUsername(res.data.username);
            this.userState.setCurrentRecipeCount(res.data.recipes);
            if (res.data.preferences) {
              this.userState.setPreferences(res.data.preferences);
            }
          });
      } catch (error) {
        reject(error);
      }
    });
  }

  updateUserData(request: UpdateUserRequest): Promise<any> {
    return new Promise(async (resolve, reject) => {
      try {
        this.http
          .put(encodeURI(`${this.webService.rootService}/user/data`), request)
          .pipe(
            catchError((err) => {
              reject(err);
              return of(null);
            }),
          )
          .subscribe((res) => {
            resolve(res);
            if (res && request.tabs) {
              this.tabsState.setTabs(request.tabs);
            }
            if (res && request.preferences) {
              this.userState.setPreferences(request.preferences);
            }
          });
      } catch (error) {
        reject(error);
      }
    });
  }

  getUsername(): Promise<string> {
    return new Promise(async (resolve, reject) => {
      try {
        const username = this.userState.getUsername();
        if (username) return resolve(username);

        const res = await this.getUserData();
        return resolve(res.data.username);
      } catch (error) {
        reject(error);
      }
    });
  }

  getPreferences(): Promise<UserPreferences | undefined> {
    return new Promise(async (resolve, reject) => {
      try {
        const preferences = this.userState.getCurrentPreferences();
        if (preferences) return resolve(preferences);

        const res = await this.getUserData();
        return resolve(res.data.preferences);
      } catch (error) {
        reject(error);
      }
    });
  }

  getMaxRecipes() {
    return 100;
  }

  async getCurrentRecipeCount(): Promise<number> {
    return new Promise(async (resolve, reject) => {
      try {
        const currentRecipeCount = this.userState.getCurrentRecipeCount();
        if (currentRecipeCount) return resolve(currentRecipeCount);

        const res = await this.getUserData();
        return resolve(res.data.recipes);
      } catch (error) {
        reject(error);
      }
    });
  }
}
